const RELOAD_KEY = 'meraayurved:chunk-reload';

/** True for stale-deploy / missing hashed chunk failures. */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : String(error ?? '');

  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message)
  );
}

/**
 * Reload once per failure burst. Avoids infinite reload if a deploy is broken.
 * Clears the guard after the app has been healthy for a short window so a later
 * release can trigger recovery again in the same tab.
 */
export function tryReloadForChunkError(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === '1') {
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, '1');
  } catch {
    // sessionStorage may be blocked; still attempt a single reload
  }
  window.location.reload();
  return true;
}

export function setupChunkLoadRecovery(): void {
  window.setTimeout(() => {
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch {
      // ignore
    }
  }, 10_000);

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    tryReloadForChunkError();
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) return;
    if (tryReloadForChunkError()) {
      event.preventDefault();
    }
  });
}
